import { render, staticRenderFns } from "./AuthorizeActivity.vue?vue&type=template&id=4715c87a&scoped=true"
import script from "./AuthorizeActivity.vue?vue&type=script&lang=js"
export * from "./AuthorizeActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4715c87a",
  null
  
)

export default component.exports